module.exports = __webpack_public_path__ + "media/components/lesson4/common/statics/displayImage-c1987afcbcabc25573310784f6f421b2.gif";